// extracted by mini-css-extract-plugin
export default {"legend":"Dna-z","legendSpacing":"Ena-z"};